<div class="form-footer-wrapper" [class.cdk-visually-hidden]="!visible">
   <div class="form-footer">
      <div>
         <ng-content></ng-content>
      </div>

      <div class="form-footer-actions">
         <ng-content select="button"></ng-content>
         <button
            type="submit"
            mat-raised-button
            color="primary"
            (click)="onSaveClick($event)"
            [disabled]="callState | lcsCallState: 'loading'"
            id="5c805a3e-c7ab-4881-8ed1-d08db56778d1"
         >
            Save
         </button>
         <button type="button" mat-stroked-button (click)="onCancelClick()" id="form-footer-cancel">Cancel</button>
      </div>
   </div>
</div>
